module.exports = __webpack_public_path__ + "ndownload_arrow.svg";